const keys = {
    SPACE: " ",
    UP: "ArrowUp",
    DOWN: "ArrowDown",
    LEFT: "ArrowLeft",
    RIGHT: "ArrowRight",
    ENTER: "Enter",
    ESCAPE: "Escape",
    TAB: "Tab",
};

export const { SPACE, UP, DOWN, LEFT, RIGHT, ENTER, ESCAPE, TAB } = keys;
